import {AbstractControl} from '@angular/forms';
import { AfterViewInit, Directive, ElementRef, Input, OnChanges, OnInit } from '@angular/core';
import {TranslateService} from '../translate';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

type PositionType = 'top' | 'button';

@Directive({
	// tslint:disable-next-line:directive-selector
	selector: '[formErrorIndicator]'
})
export class FormErrorIndicatorDirective implements OnInit, OnChanges, AfterViewInit {
	@Input() formErrorIndicator: AbstractControl;
	@Input() position: PositionType = 'button';
	@Input() highlightClass = '';
	
	errorRootNode: HTMLElement = null;
	asyncValidatorLoaderNode: HTMLElement = null;
	
	errorMap: { [key: string]: HTMLElement} = {};
	
	// Служит для ограничения срабатываний кол-ва валидаций, ибо при валидации идёт работа с DOM
	// Да, руками делаем DOM - пока не знаю лучшего решения
	validateEvent = new Subject();
	
	constructor(
		private el: ElementRef,
		public translate: TranslateService,
	) {
		this.validateEvent.pipe(
			debounceTime(100)
		).subscribe(() => this.update());
	}
	
	
	update() {
		const
			me = this,
			el = this.el.nativeElement;
		
		if ( ! me.formErrorIndicator) {
			return true;
		}
		
		if (me.formErrorIndicator.status === 'DISABLED') {
			me.removeRootEl();
			
			return true;
		}
		
		if (me.formErrorIndicator.status === 'VALID') {
			me.removeRootEl();
			
			if (me.asyncValidatorLoaderNode) {
				me.asyncValidatorLoaderNode.remove();
				me.asyncValidatorLoaderNode = null;
			}
			
			return true;
		}
		
		if (me.formErrorIndicator.status === 'PENDING') {
			if ( ! me.asyncValidatorLoaderNode) {
				me.asyncValidatorLoaderNode = document.createElement('div');
				me.asyncValidatorLoaderNode.innerHTML = `<div>Checking...</div>`;
				
				el.parentNode.insertBefore(me.asyncValidatorLoaderNode, el.nextSibling);
			}
			
			
			return ;
		}
		
		if (me.asyncValidatorLoaderNode) {
			me.asyncValidatorLoaderNode.remove();
			me.asyncValidatorLoaderNode = null;
		}
		
		// Поскольку мы не знаем списка всех валидаторов для элемента формы,
		// тогда проще все удалить и построить заново
		me.clearErrorList();
		
		if ( ! me.formErrorIndicator.errors) {
			return ;
		}
		
		const errorNameList = Object.keys(me.formErrorIndicator.errors);
		if (errorNameList.length > 0) {
			if ( ! me.errorRootNode) {
				me.errorRootNode = document.createElement('div');
				me.errorRootNode.className = 'alert alert-danger';
				
				const parentNode = el.parentNode as HTMLElement;
				if (me.position === 'top') {
					el.parentNode.insertBefore(me.errorRootNode, el);
				} else if (me.position === 'button') {
					el.parentNode.insertBefore(me.errorRootNode, el.nextSibling);
				} else {
					throw new Error(`Input position has not valid value "${me.position}"`);
				}
				
				if (me.highlightClass) {
					const classList = me.highlightClass.split(' ');
					
					classList.forEach(str => {
						if ( ! parentNode.classList.contains(str)) {
							parentNode.classList.add(str);
						}
					});
				}
			}
			
			errorNameList.forEach(key => {
				const error = me.formErrorIndicator.errors[key];
				let errorText = key;
				if (error.message) {
					errorText = error.message;
				} else if (error.i18n) {
					errorText = me.translate.__A(error.i18n, ...error.params);
				}
				
				const node = document.createElement('div');
				node.innerHTML = `<div>${errorText}</div>`;
				me.errorRootNode.appendChild(node);
				
				me.errorMap[key] = node;
			});
		}
	}
	
	
	clearErrorList() {
		const me = this;
		
		// удаляем ноды сообщений об ошибках
		Object.keys(me.errorMap).forEach(key => {
			me.errorMap[key].remove();
			delete me.errorMap[key];
		});
	}
	
	
	removeRootEl() {
		const me = this;
		
		if (me.errorRootNode) {
			me.clearErrorList();
			
			const parentNode = me.el.nativeElement.parentNode as HTMLElement;
			if (me.highlightClass) {
				const classList = me.highlightClass.split(' ');
				
				classList.forEach(str => {
					if (parentNode.classList.contains(str)) {
						parentNode.classList.remove(str);
					}
				});
			}
			
			me.errorRootNode.remove();
			me.errorRootNode = null;
		}
	}
	
	
	ngOnInit() {
		if ( ! this.formErrorIndicator) {
			return true;
		}
		
		this.formErrorIndicator.statusChanges.subscribe(() => this.validateEvent.next());
		this.formErrorIndicator.valueChanges.subscribe(() => this.validateEvent.next());
	}
	
	
	ngOnChanges() {
		this.validateEvent.next();
	}
	
	
	ngAfterViewInit() {
		this.validateEvent.next();
	}
}
